var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg1Passwordlock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 126,
    height: 126,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.3,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.2,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    id: "b",
    d: "M60 0c33.14 0 60 26.86 60 60s-26.86 60-60 60S0 93.14 0 60 26.86 0 60 0zm0 109.2c27.17 0 49.2-22.03 49.2-49.2S87.17 10.8 60 10.8 10.8 32.83 10.8 60s22.03 49.2 49.2 49.2z"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    width: "107.5%",
    height: "107.5%",
    x: "-3.8%",
    y: "-2.9%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowBlurOuter1",
    in2: "SourceAlpha",
    operator: "out",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("path", {
    id: "d",
    d: "M119.95 57.6c.03.8.05 1.6.05 2.4 0 33.14-26.86 60-60 60S0 93.14 0 60c0-.8.02-1.6.05-2.4C1.3 89.62 27.67 115.2 60 115.2s58.7-25.57 59.95-57.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.25,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.15,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    id: "e",
    d: "M60 22.8c20.55 0 37.2 16.66 37.2 37.2S80.54 97.2 60 97.2 22.8 80.54 22.8 60 39.45 22.8 60 22.8z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g",
    cy: "76.73%",
    r: "62.46%",
    fx: "50%",
    fy: "76.73%",
    gradientTransform: "matrix(0 -1 .97942 0 -.25 1.267)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4F4F4",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: "50%",
    x2: "50%",
    y1: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCC",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    id: "h",
    d: "M60 42c9.94 0 18 8.06 18 18s-8.06 18-18 18-18-8.06-18-18 8.06-18 18-18z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: "50%",
    x2: "50%",
    y1: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D4D4D",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    id: "j",
    d: "M51.6 49.96V35.4c0-.33.27-.6.6-.6h15.6c.33 0 .6.27.6.6v26.85c0 .16-.07.32-.2.43l-3.17 3.03c-.24.24-.25.62-.02.86l.03.02 3.18 3.03c.13.12.2.28.2.44V84.6c0 .33-.27.6-.6.6H52.2c-.33 0-.6-.27-.6-.6V57.75c0-.16.07-.32.2-.43l3.17-3.03c.24-.24.25-.62.02-.86l-.03-.02-3.18-3.03c-.13-.12-.2-.28-.2-.44z"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "k",
    width: "201.2%",
    height: "133.7%",
    x: "-50.6%",
    y: "-16.9%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.681244339 0",
    in: "shadowInnerInner1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(3 2)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#a)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#c)",
    d: "M60-.5c33.4 0 60.5 27.1 60.5 60.5S93.4 120.5 60 120.5-.5 93.4-.5 60 26.6-.5 60-.5zm0 109.2c26.9 0 48.7-21.8 48.7-48.7 0-26.9-21.8-48.7-48.7-48.7-26.9 0-48.7 21.8-48.7 48.7 0 26.9 21.8 48.7 48.7 48.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.15,
    d: "M108.16 70.1c1.46-4.72 2.24-9.72 2.24-14.9 0-27.84-22.57-50.4-50.4-50.4S9.6 27.37 9.6 55.2c0 5.18.78 10.18 2.24 14.9-.68-3.27-1.04-6.64-1.04-10.1 0-27.17 22.03-49.2 49.2-49.2s49.2 22.03 49.2 49.2c0 3.46-.36 6.83-1.04 10.1z"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    fillOpacity: 0.15,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#F2F2F2",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#f)",
    d: "M60 22.3c20.82 0 37.7 16.88 37.7 37.7 0 20.82-16.88 37.7-37.7 37.7-20.82 0-37.7-16.88-37.7-37.7 0-20.82 16.88-37.7 37.7-37.7z"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#g)",
    xlinkHref: "#h"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#i)",
    d: "M60 41.5c10.22 0 18.5 8.28 18.5 18.5S70.22 78.5 60 78.5 41.5 70.22 41.5 60 49.78 41.5 60 41.5z"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#606B73",
    xlinkHref: "#j"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#k)",
    xlinkHref: "#j"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#l)",
    strokeWidth: 1.2,
    d: "M52.2 49.96L55.4 53l.03.03c.46.48.44 1.24-.04 1.7l-3.2 3.02V84.6h15.6V70.04L64.6 67l-.03-.03c-.46-.48-.44-1.24.04-1.7l3.2-3.02V35.4H52.2v14.56z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg1Passwordlock);
export default __webpack_public_path__ + "static/media/1passwordlock.faf49056c29661b7b93d9d68e7b78ced.svg";
export { ForwardRef as ReactComponent };